<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="about" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Privacy Policy</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)"
                data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div class="body" [innerHTML]="myHTML"></div>
</ion-content>